import { Provider } from '@angular/core';
import { ZipWorkerService } from './zip-worker.service';
import { ZIP_WORKER } from './zip-worker.token';

/**
 * Provides the dedicated zip decompression worker. The worker is created
 * eagerly (unzip is needed for any zip-based package load, unlike IPFS/
 * FlexSearch which are behind their own feature flags), gated only on Web
 * Worker support.
 *
 * Deliberately kept in the `shared/zip` folder — separate from
 * `shared/workers/provide.ts` — so that wiring it into the eager app
 * config does not pull that file's `@xenova/transformers`-backed worker
 * imports into the main bundle (see `ipfs-worker.provider.ts` for the same
 * reasoning).
 */
export function provideZipWorker(): Provider[] {
  return [
    ZipWorkerService,
    {
      provide: ZIP_WORKER,
      useFactory: () =>
        typeof Worker !== 'undefined'
          ? new Worker(new URL('../../shared/workers/zip.worker', import.meta.url))
          : null,
    },
  ];
}
